import { lazy } from "react";

const Farmermap = lazy(() => import("./Farmermap"));

const farmermapRoutes = [
  {
    path: "/farmermap",
    component: Farmermap,
  },
];

export default farmermapRoutes;
